import React from "react";
import "../../css/sharedStyles.css";
import "./comicCreators.css";

var ComicCreators = class ComicCreators extends React.Component{
    
  componentDidUpdate(prevProps){
    //console.log("PREVIOUS: " + prevProps.mainComicInfo.comicID + " | END: " +  this.props.mainComicInfo.comicID);
  }


    render() {
      const inlineStyle = {
        marginBottom:"10px",
        marginTop:"0",
        width:'100%',
        paddingTop:'10px',
        paddingBottom:'10px'
      }
      

      return (
        <div>

            <div className = {this.props.textStyle}>
                {
                  this.props.mainComicInfo.creators.map(function(creatorsType,index){ 
                    return <div key = {index} className = "creatorsRow">
                              <div>
                                <span className="creatorTitle">{creatorsType[0]}:  </span>
                                { creatorsType[1] }
                              </div>
                              
                              
                             
                          </div>
                  }) 

                }

            </div>

        </div>
      );
    }
  }

  export default ComicCreators;


// WEBPACK FOOTER //
// ./src/components/comicDetail/ComicCreators.js